// https://vuex.vuejs.org/en/getters.html

export default {
  //
  getDebug: (state) => {
    return state.debug
  },
  getLoading: (state) => {
    return state.loading
  },
  getMenuControl: (state) => {
    return state.menuControl
  },
  getIsLogged: (state) => {
    return state.isLogged
  },

  getUID: (state) => {
    return state.uid
  },
  getDisplayName: (state) => {
    return state.displayName
  },
  getEmail: (state) => {
    return state.email
  },
  getLevel: (state) => {
    return state.level
  },


  getNotifyMessage: (state) => {
    return state.notifyMessage
  },
  getNotifyTimeout: (state) => {
    return state.notifyTimeout
  },

  getAllProducts: (state) => {
    return state.allProducts
  },
  getThisOrder: (state) => {
    return state.thisOrder
  }
 
}
